// Text helpers shared by the build-time prerender (scripts/prerender) and the
// runtime <Helmet> on the course page. Both have to derive the same description
// from the same HTML body, so the derivation lives in one place. Pure string
// work only — no DOM, no Node built-ins — because it runs in both.

const BLOCK_TAGS =
	"address|article|aside|blockquote|div|dl|dd|dt|fieldset|figcaption|figure|footer|form|h[1-6]|header|hr|li|main|nav|ol|p|pre|section|table|tbody|td|tfoot|th|thead|tr|ul";

const ENTITIES = {
	"&amp;": "&",
	"&lt;": "<",
	"&gt;": ">",
	"&quot;": '"',
	"&#39;": "'",
	"&apos;": "'",
	"&nbsp;": " ",
};

export function stripHtml(html) {
	if (!html) return "";
	return String(html)
		.replace(/<(script|style)\b[^>]*>[\s\S]*?<\/\1>/gi, "")
		.replace(new RegExp(`</?(?:${BLOCK_TAGS})\\b[^>]*>`, "gi"), " ")
		.replace(/<[^>]+>/g, "")
		.replace(/&[a-z#0-9]+;/gi, (m) => ENTITIES[m.toLowerCase()] ?? m)
		.replace(/\s+/g, " ")
		.trim();
}

export function truncateAtWord(str, maxLen) {
	if (!str) return "";
	const text = String(str).trim();
	if (text.length <= maxLen) return text;

	const slice = text.slice(0, maxLen);
	const lastSpace = slice.lastIndexOf(" ");
	const cut = lastSpace > 0 ? slice.slice(0, lastSpace) : slice;

	return cut.replace(/[\s.,;:!?–—-]+$/u, "");
}

export function deriveDescription(html, maxLen = 155) {
	let text = stripHtml(html);
	if (!text) return "";

	text = text.replace(/^(?:O ovom kursu|About this course)\s*/i, "");

	return truncateAtWord(text, maxLen);
}
